module.exports = __webpack_public_path__ + "img/cooker-dome-back-valves_140x116.7bfbe4cb.png";